// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.8 10.7L5.24 7.26C5.55 6.95 6.05 6.95 6.36 7.26L8.04 8.94C8.35 9.25 8.85 9.25 9.16 8.94L14.1 4',
  'M10.5 4H14.1V7.6',
];
